import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import es from './es.json';

// Sólo el español viaja en el bundle principal. Los dos JSON juntos eran 1,4 MB de los
// 3,4 MB de main.js (42 %): cada agente descargaba y parseaba en cada carga un idioma que
// no usa. Casi todos usan español (y es el fallback), así que el inglés es un chunk
// aparte que se pide sólo cuando hace falta. index.js espera `i18nReady` antes del primer
// render, así un usuario en inglés nunca ve la interfaz a medio traducir.
const isEn = (lng) => String(lng || '').toLowerCase().startsWith('en');
let enLoad = null;
function loadEn() {
  if (!enLoad) {
    enLoad = import(/* webpackChunkName: "i18n-en" */ './en.json')
      .then((m) => { i18n.addResourceBundle('en', 'translation', m.default || m, true, true); })
      .catch((err) => { enLoad = null; throw err; });
  }
  return enLoad;
}

// El nombre de ESTA instancia, del mismo cache que usa utils/brand.js. Se lee sincrónico
// porque i18n se inicializa antes de que vuelva el fetch de /api/brand.
function leerMarca() {
  try { return JSON.parse(localStorage.getItem('brand_v1') || 'null')?.name || 'AyudaTecno'; }
  catch { return 'AyudaTecno'; }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { es: { translation: es } },
    fallbackLng: 'es',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
      // {{marca}} disponible en TODA cadena sin pasarla en cada t(). Las traducciones
      // tenían "AyudaTecno" cocido en 31 lugares por idioma, y en el helpdesk de un colegio
      // eso aparecía en avisos, títulos y textos de bienvenida: el nombre de otra empresa
      // dentro de su propia plataforma. Resolverlo acá evita 62 ediciones y, sobre todo,
      // evita que la próxima cadena nueva vuelva a nacer con la marca cocida.
      // Se lee del cache que deja utils/brand.js; si todavía no cargó, cae a AyudaTecno,
      // que es lo correcto para nuestra instancia.
      defaultVariables: { marca: leerMarca() },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

// Cambio de idioma en caliente (perfil del usuario al loguear, selector de idioma): si
// pasa a inglés y el chunk no está, se pide y se vuelve a avisar para que re-renderice.
i18n.on('languageChanged', (lng) => {
  if (isEn(lng) && !i18n.hasResourceBundle('en', 'translation')) {
    loadEn().then(() => { if (isEn(i18n.language)) i18n.emit('languageChanged', i18n.language); }).catch(() => {});
  }
});

// El primer render espera esto. Inglés por detector, o por ?lang=en (IntegrationChat usa
// getFixedT(lang) sin cambiar el idioma global, así que también lo necesita cargado).
// Si el chunk falla, igual se renderiza: en español, que es el fallback.
let urlLang = null;
try { urlLang = new URLSearchParams(window.location.search).get('lang'); } catch { /* nada */ }
export const i18nReady = (isEn(i18n.language) || isEn(urlLang)) ? loadEn().catch(() => {}) : Promise.resolve();

// Cuando /api/brand responde (primera visita, o si cambió el nombre), se actualiza la
// variable global. Sin esto, la primera carga de un cliente nuevo mostraría "AyudaTecno"
// hasta el siguiente refresh.
export function actualizarMarcaI18n(nombre) {
  if (!nombre) return;
  i18n.options.interpolation.defaultVariables.marca = nombre;
  i18n.emit('languageChanged');   // fuerza el re-render de lo ya traducido
}

export default i18n;
